import { render, staticRenderFns } from "./DashboardWidget.vue?vue&type=template&id=7f5cca66&scoped=true"
import script from "./DashboardWidget.vue?vue&type=script&lang=js"
export * from "./DashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidget.vue?vue&type=style&index=0&id=7f5cca66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5cca66",
  null
  
)

export default component.exports